var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"us-pc-dialog btn-close",attrs:{"title":"提示","visible":_vm.dialogVisible,"width":"60%","before-close":_vm.onCancel},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('span',[_vm._v("请使用电脑端访问")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onCancel}},[_vm._v("确 定")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/us-pc-dialog.vue?vue&type=template&id=b72b15fe
// module id = null
// module chunks = 